export default __webpack_public_path__ + "static/media/AUTO_PAY_FORM.9008b3f0.pdf";